"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHighestHeadlineBoostReward = exports.HEADLINE_ELIGIBLE_BOOST_NAMES = exports.mapBoostNamesToRewardNames = exports.mapBoostNameToRewardName = exports.mapSupportedBoostNameToRewardName = exports.DEPOSIT_BASE_CASH_BACK_RATIO_TO_REWARD_NAME = exports.isDepositBoostName = exports.DEPOSIT_BOOST_NAMES = exports.isSupportedBoostName = exports.UNSUPPORTED_BOOST_NAMES = void 0;
const lodash_1 = __importDefault(require("lodash"));
const assertUtils_1 = require("../assertUtils");
const avenBoostRewards_1 = require("../origination/avenBoostRewards");
const rewardDefinitions_1 = require("../reward/rewardImplementation/rewardDefinitions");
const rewardLimitRule_1 = require("../reward/rewardRules/rewardLimitRule");
const rewards_1 = require("../rewards");
exports.UNSUPPORTED_BOOST_NAMES = [
    avenBoostRewards_1.AvenBoostRewardsName._test,
    avenBoostRewards_1.AvenBoostRewardsName.ascendaHotelsCashBack5pct,
    avenBoostRewards_1.AvenBoostRewardsName.ascendaHotelsCashBack7pct,
    avenBoostRewards_1.AvenBoostRewardsName.ascendaFlightsCashBack5pct,
];
const UNSUPPORTED_BOOST_NAMES_SET = new Set(exports.UNSUPPORTED_BOOST_NAMES);
const isSupportedBoostName = (boostName) => {
    return !UNSUPPORTED_BOOST_NAMES_SET.has(boostName);
};
exports.isSupportedBoostName = isSupportedBoostName;
// A deposit account has no autopay and no bill pay, so most credit boosts cannot be earned on one - deposit opts in by name.
exports.DEPOSIT_BOOST_NAMES = [avenBoostRewards_1.AvenBoostRewardsName.forestRiverMerchant2pctWith5kAnnualLimit];
const DEPOSIT_BOOST_NAMES_SET = new Set(exports.DEPOSIT_BOOST_NAMES);
const isDepositBoostName = (boostName) => {
    return DEPOSIT_BOOST_NAMES_SET.has(boostName);
};
exports.isDepositBoostName = isDepositBoostName;
// HeraclesParameters defaults the base rate to 1.5%, so a deposit policy that omits it reads as a deliberate 1.5% - listing the rates deposit offers is what catches that.
exports.DEPOSIT_BASE_CASH_BACK_RATIO_TO_REWARD_NAME = {
    0.01: rewards_1.RewardName.onePctBaseUnlimitedUnconditional,
};
/**
 * Maps a supported boost reward name to a unique reward name (1-to-1 mapping).
 * @param boostName - The supported boost reward name to map
 * @returns The corresponding RewardName
 */
const mapSupportedBoostNameToRewardName = (boostName) => {
    switch (boostName) {
        case avenBoostRewards_1.AvenBoostRewardsName.homedepotCashBack5pct:
            return rewards_1.RewardName.fivePctSpecificHomeDepotLimitedOneThousandPerCycleUnconditional;
        case avenBoostRewards_1.AvenBoostRewardsName.homedepotCashBack5pctAutoPayEnabled:
            return rewards_1.RewardName.fivePctSpecificHomeDepotLimitedOneThousandPerCycleConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant3pctAutoPayEnabled:
            return rewards_1.RewardName.threePctBaseLimitedOneThousandPerCycleConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant5pctAutoPayEnabled:
            return rewards_1.RewardName.fivePctBaseLimitedFiveHundredPerCycleConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant5pct5DaysAutoPayEnabled:
            return rewards_1.RewardName.fivePctBaseLimitedOneThousandPerLifetimeConditionalAutopayFiveDaysAfterEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant3pctAutoPayEnabledAnnualLimit:
            return rewards_1.RewardName.threePctBaseLimitedTenThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant4pctAutoPayEnabled1YearWith10kLimit:
            return rewards_1.RewardName.fourPctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant5pctAutoPayEnabledAnnualLimit:
            return rewards_1.RewardName.fivePctBaseLimitedTenThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant5pctAutoPayEnabled1Year10kLimit:
            return rewards_1.RewardName.fivePctBaseLimitedTenThousandPerLifetimeConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant3pctAutoPayEnabledWith200kAnnualLimit:
            return rewards_1.RewardName.threePctBaseLimitedTwoHundredThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant5pctWith20kLifetimeForBundle:
            return rewards_1.RewardName.fivePctBaseLimitedTwentyThousandPerLifetimeUnconditional;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant5pctWith25kAnnualForCheckingBundle:
            return rewards_1.RewardName.fivePctBaseLimitedFiveThousandPerCycleTwentyFiveThousandPerYearConditionalAutopayEnabledAndRewardsDepositBundleEnrollmentActive;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant5pctWithSelectedAnnualForCheckingBundle:
            return rewards_1.RewardName.fivePctBaseLimitedSelectedMonthlyAmountPerCycleSelectedAmountPerYearConditionalAutopayEnabledAndRewardsDepositBundleEnrollmentActive;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant3pctBiMonthlyOrMinDueAutoPayEnabled10kAnnualLimit:
            return rewards_1.RewardName.threePctBaseLimitedTenThousandPerYearConditionalAutopayMinimumDueOrBiMonthlyCurrentBalance;
        case avenBoostRewards_1.AvenBoostRewardsName.gasStations7pctMcc5541:
            return rewards_1.RewardName.sevenPctSpecificGasStationsLimitedFiveThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.gasStations7pctMcc5542:
            return rewards_1.RewardName.sevenPctSpecificAutomatedFuelDispensersLimitedFiveThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.groceriesAndSupermarkets7pct:
            return rewards_1.RewardName.sevenPctSpecificGroceriesAndSupermarketsLimitedFiveThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.gas6pct:
            return rewards_1.RewardName.sixPctSpecificGasStationsAndAutomatedFuelDispensersLimitedTenThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.groceries6pct:
            return rewards_1.RewardName.sixPctSpecificGroceriesSupermarketsAndMiscFoodStoresLimitedTenThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.gasAndGroceries7pct:
            return rewards_1.RewardName.sevenPctSpecificGasAndGroceriesLimitedFiveThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.gasAndGroceries7pctWith10kLimit:
            return rewards_1.RewardName.sevenPctSpecificGasAndGroceriesLimitedTenThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.gasGroceriesUtilities5pctWith10kLimit:
            return rewards_1.RewardName.fivePctSpecificGasGroceriesAndUtilitiesLimitedTenThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.restaurants7pct:
            return rewards_1.RewardName.sevenPctSpecificRestaurantsLimitedTenThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.restaurants7pctWith5kLifetimeLimit:
            return rewards_1.RewardName.sevenPctSpecificRestaurantsLimitedFiveThousandPerLifetimeConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.restaurants7pctUpgrade10kLifetimeLimit:
            return rewards_1.RewardName.sevenPctSpecificRestaurantsLimitedTenThousandPerLifetimeConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.travel7pctWith5kLifetimeLimit:
            return rewards_1.RewardName.sevenPctSpecificTravelLimitedFiveThousandPerLifetimeConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.travel7pctUpgrade10kLifetimeLimit:
            return rewards_1.RewardName.sevenPctSpecificTravelLimitedTenThousandPerLifetimeConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.homeImprovement7pctWith5kLifetimeLimit:
            return rewards_1.RewardName.sevenPctSpecificHomeImprovementLimitedFiveThousandPerLifetimeConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.homeImprovement7pctUpgrade10kLifetimeLimit:
            return rewards_1.RewardName.sevenPctSpecificHomeImprovementLimitedTenThousandPerLifetimeConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.utilitiesGasAndEvCharging7pctWith5kLifetimeLimit:
            return rewards_1.RewardName.sevenPctSpecificUtilitiesGasAndEvChargingLimitedFiveThousandPerLifetimeConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.utilitiesGasAndEvCharging7pctUpgrade10kLifetimeLimit:
            return rewards_1.RewardName.sevenPctSpecificUtilitiesGasAndEvChargingLimitedTenThousandPerLifetimeConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.groceries7pctWith5kLifetimeLimit:
            return rewards_1.RewardName.sevenPctSpecificGroceriesSupermarketsAndMiscFoodStoresLimitedFiveThousandPerLifetimeConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.groceries7pctUpgrade10kLifetimeLimit:
            return rewards_1.RewardName.sevenPctSpecificGroceriesSupermarketsAndMiscFoodStoresLimitedTenThousandPerLifetimeConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.starbucksDunkin5pct:
            return rewards_1.RewardName.fivePctSpecificStarbucksDunkinLimitedFourThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant3pctWith100kAnnualLimit:
            return rewards_1.RewardName.threePctBaseLimitedOneHundredThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.pointOfSaleMerchant5pct20kLimit:
            return rewards_1.RewardName.fivePctSpecificPointOfSaleMerchantsLimitedTwentyThousandPerLifetimeUnconditional;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant3pctWith100kLifetime:
            return rewards_1.RewardName.threePctBaseLimitedOneHundredThousandPerLifetimeConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant10pctWith15kLifetime:
            return rewards_1.RewardName.tenPctBaseLimitedFifteenThousandPerLifetimeUnconditional;
        case avenBoostRewards_1.AvenBoostRewardsName.autoPayNotRequired3pct:
            return rewards_1.RewardName.threePctBaseLimitedTenThousandPerYearUnconditional;
        case avenBoostRewards_1.AvenBoostRewardsName.hoa2pctWith20kYearlyLimitOnExternallBill:
            return rewards_1.RewardName.twoPctSpecificHOAPaymentsLimitedTwentyThousandPerYearUnconditional;
        case avenBoostRewards_1.AvenBoostRewardsName.allMerchant6pctAutoPayEnabledWith10kAnnualLimit:
            return rewards_1.RewardName.sixPctBaseLimitedTenThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.semperFiMerchant5pctUnlimited:
            return rewards_1.RewardName.fivePctSpecificSemperFiMerchantUnlimitedUnconditional;
        case avenBoostRewards_1.AvenBoostRewardsName.typeFiveMerchant5pctUnlimited:
            return rewards_1.RewardName.fivePctSpecificTypeFiveMerchantUnlimitedUnconditional;
        case avenBoostRewards_1.AvenBoostRewardsName.forestRiverMerchant2pctWith5kAnnualLimit:
            return rewards_1.RewardName.twoPctSpecificCobrandPartnerMerchantsLimitedFiveThousandPerYearUnconditional;
        case avenBoostRewards_1.AvenBoostRewardsName.cobrandPartnerMerchant3pctWith50kAnnualLimit:
            return rewards_1.RewardName.threePctSpecificCobrandPartnerMerchantsLimitedFiftyThousandPerYearConditionalAutopayEnabled;
        case avenBoostRewards_1.AvenBoostRewardsName.cobrandPartnerMerchant3pctWith10kAnnualLimit:
            return rewards_1.RewardName.threePctSpecificCobrandPartnerMerchantsLimitedTenThousandPerYearUnconditional;
        default:
            return (0, assertUtils_1.assertNever)(boostName, `Unknown boost name: ${boostName}`);
    }
};
exports.mapSupportedBoostNameToRewardName = mapSupportedBoostNameToRewardName;
/**
 * Maps a boost reward name to a reward name, returning null for unsupported/deprecated boost names.
 * @param boostName - The boost reward name to map
 * @returns The corresponding RewardName, or null if the boost name is unsupported
 */
const mapBoostNameToRewardName = (boostName) => {
    if (!(0, exports.isSupportedBoostName)(boostName)) {
        return null;
    }
    return (0, exports.mapSupportedBoostNameToRewardName)(boostName);
};
exports.mapBoostNameToRewardName = mapBoostNameToRewardName;
/**
 * Maps an array of boost reward names to reward names, filtering out unsupported/deprecated ones.
 * @param boostNames - Array of boost reward names to map
 * @returns Array of corresponding RewardNames (unsupported boost names are filtered out)
 */
const mapBoostNamesToRewardNames = (boostNames) => {
    return boostNames.map((boostName) => (0, exports.mapBoostNameToRewardName)(boostName)).filter((rewardName) => rewardName !== null);
};
exports.mapBoostNamesToRewardNames = mapBoostNamesToRewardNames;
/** The boosts that upgrade ads (e.g. the UCC to Home green beard) are allowed to headline. */
exports.HEADLINE_ELIGIBLE_BOOST_NAMES = new Set([
    avenBoostRewards_1.AvenBoostRewardsName.allMerchant3pctAutoPayEnabledAnnualLimit,
    avenBoostRewards_1.AvenBoostRewardsName.allMerchant4pctAutoPayEnabled1YearWith10kLimit,
    avenBoostRewards_1.AvenBoostRewardsName.allMerchant5pctAutoPayEnabledAnnualLimit,
    avenBoostRewards_1.AvenBoostRewardsName.allMerchant5pctAutoPayEnabled1Year10kLimit,
]);
/**
 * Returns the cash back ratio and spend cap of the highest-rate headline-eligible boost among the
 * given boost names, or null if none apply. Only boosts in HEADLINE_ELIGIBLE_BOOST_NAMES are considered.
 * @param boostCashBackNames - The policy's boost reward names
 */
const getHighestHeadlineBoostReward = (boostCashBackNames) => {
    let headlineDefinition;
    for (const boostName of boostCashBackNames) {
        if (!exports.HEADLINE_ELIGIBLE_BOOST_NAMES.has(boostName)) {
            continue;
        }
        const rewardName = (0, exports.mapBoostNameToRewardName)(boostName);
        if (rewardName === null) {
            continue;
        }
        const definition = rewardDefinitions_1.rewardDefinitions[rewardName];
        if (!headlineDefinition || definition.cashbackRatio > headlineDefinition.cashbackRatio) {
            headlineDefinition = definition;
        }
    }
    if (!headlineDefinition) {
        return null;
    }
    const limitRule = headlineDefinition.limitRules[0];
    const fixedAmountDollars = (0, rewardLimitRule_1.getFixedLimitAmountDollars)(limitRule);
    if (!limitRule || lodash_1.default.isNil(fixedAmountDollars)) {
        return { cashbackRatio: headlineDefinition.cashbackRatio, limit: null };
    }
    return { cashbackRatio: headlineDefinition.cashbackRatio, limit: { amount: fixedAmountDollars, type: limitRule.rewardLimitType } };
};
exports.getHighestHeadlineBoostReward = getHighestHeadlineBoostReward;
